import React, { useEffect } from "react";
import { Bot, X } from "lucide-react";
import ChatContainer from "./ChatContainer";
import { useChat } from "../hooks/useChat";

const ChatBox = ({ onClose }) => {
    const { messages, isLoading, sendMessage, clearMessages } = useChat();

    // Close on Escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [onClose]);

    return (
        <div
            className="
                fixed bottom-28 right-20
                w-[400px] h-[600px]
                bg-white rounded-2xl
                shadow-2xl border border-gray-200
                flex flex-col overflow-hidden
                z-[60]
                animate-slide-up
            "
        >
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-acs-primary-green/10 to-teal-50">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-gradient-to-br from-acs-primary-green to-teal-400 rounded-lg flex items-center justify-center">
                        <Bot className="w-5 h-5 text-white" />
                    </div>
                    <div>
                        <h3 className="text-sm font-semibold text-gray-800">Ascendrix</h3>
                        <p className="text-xs text-gray-500">Ask me anything</p>
                    </div>
                </div>

                <button
                    onClick={onClose}
                    className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
                    aria-label="Close chat"
                >
                    <X className="w-5 h-5 text-gray-500" />
                </button>
            </div>

            {/* Chat Container */}
            <div className="flex-1 min-h-0 overflow-hidden">
                <ChatContainer
                    messages={messages}
                    isLoading={isLoading}
                    onSendMessage={sendMessage}
                    onClear={clearMessages}
                />
            </div>
        </div>
    );
};

export default ChatBox;
